import { atom, RecoilState } from 'recoil'

export const localesState: RecoilState<string> = atom({
	key: 'localesState',
	default: localStorage.getItem('bb_locale') ?? 'da',
})

export const subheaderState: RecoilState<string> = atom({
	key: 'subheaderState',
	default: '',
})

export const queryMatchState: RecoilState<number> = atom({
	key: 'queryMatchState',
	default: -1,
})

export const userLocationsAtom = atom<any[]>({ key: 'userLocations', default: [] })
export const userStylesAtom = atom<{ [k: string]: any }>({ key: 'userStyles', default: {} })
